import React, { Component } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";

import { generateInput } from "../utils/misc";

import Form from "../utils/Form";

class FileModal extends Component {
    // storageDir: `chat/${!this.props.isPrivateChannel ? "public" : "private"}`,

    fields = [
        generateInput({
            name: "image",
            type: "file",
            element: "file",
            label: "file types: jpg, png",
            storageDir: "chat/public",
            formNoValidate: true,
        }),
    ];

    render() {
        const { modalOpen, closeModal, onSubmit, isPrivateChannel } = this.props;

        return (
            <Modal basic open={modalOpen} onClose={closeModal} className="modal-form">
                <Modal.Header className="title">
                    <h2>select an image file</h2>
                </Modal.Header>

                <Modal.Content>
                    <div className="form-container">
                        <div className="form-wrapper">
                            <Form
                                form="uploadMedia"
                                fields={this.fields}
                                onSubmit={formValues => onSubmit(formValues, "image", closeModal)}>
                                <Modal.Actions>
                                    <Button color="green" inverted type="submit">
                                        <Icon name="checkmark" /> send
                                    </Button>
                                    <Button color="red" inverted onClick={closeModal}>
                                        <Icon name="remove" /> cancel
                                    </Button>
                                </Modal.Actions>
                            </Form>
                        </div>
                    </div>
                </Modal.Content>
            </Modal>
        );
    }
}

export default FileModal;
